module.exports = __webpack_public_path__ + "static/media/flowers.9d8690e0.jpg";